import React from "react";
import { usePatientDocumentCreateMutation } from "../../../../../api/patientDocuments/usePatientDocumentCreateMutation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { history } from "../../../../../history";
import { getPathParams } from "../utilities";
import { extractApiError } from "../../../../../utilities/api";
import { CLIENTS_ROUTES } from "../../../../../consts/routes";
import { MESSAGES } from "../config";

import { usePermission } from "../../../../../hooks/usePermission";
import { DOCUMENT_TYPES } from "../../../../../api/patientDocuments/usePatientDocumentsQuery";

export var withDocumentCreate = (Component) => (props) => {
  var { patientId } = getPathParams();

  const { permitted: canManageMedicalHistory } = usePermission(
    "manage-medical-history",
  );

  var { mutateAsync, isLoading } = usePatientDocumentCreateMutation({
    onSuccess: () => {
      uiNotification.success("Document created successfully");
      history.push(CLIENTS_ROUTES.newDocuments(patientId));
    },
    onError: (res) => {
      var message = extractApiError(res);
      uiNotification.error(
        MESSAGES[message] ||
          "Unable to create document. Please try again later.",
      );
    },
  });

  var initiate = async (documents) => {
    if (
      !canManageMedicalHistory &&
      documents.some(
        (document) => document.doc_type === DOCUMENT_TYPES.medicalHistory,
      )
    ) {
      return uiNotification.error(
        "You do not have permission to manage medical history",
      );
    }

    if (
      documents.some((x) => {
        return !x.name || !x.filename || !x.doc_type;
      })
    ) {
      return uiNotification.error("Please fill all required fields");
    }

    await mutateAsync({
      patientId,
      documents,
    });
  };

  return (
    <Component
      {...props}
      createDocument={{
        initiate,
        isLoading,
      }}
    />
  );
};
